import {
  createBeneficiaryBankRoutingCodeSchema,
  getBeneficiaryBankFormConfig,
} from '@peanuds/shared';

import type { RecipientEntrySchemeDefinition } from '../../recipient-entry.types';

export const sepaRecipientEntryScheme: RecipientEntrySchemeDefinition = {
  id: 'sepa',
  config: getBeneficiaryBankFormConfig('sepa'),
  createRoutingCodeSchema: () => createBeneficiaryBankRoutingCodeSchema('sepa'),
  toRoutingCodes: (routingCode) => {
    if (routingCode.length === 0) {
      return {} as Record<string, string>;
    }

    return { bic: routingCode };
  },
};
